export default {"src":"/_next/static/media/step3.24958684.gif","height":727,"width":356,"blurWidth":0,"blurHeight":0};